import {ROOT_URL} from '@/store';
import JsEncrypt from 'jsencrypt';

export function changePasswordRequest(oldPassword, newPassword) {
  const ans = fetch(ROOT_URL+'/auth/get_crypt_session/', {
    method: 'GET',
  }).then(async function(result) {
    const jsonData = await result.json();

    const cryptSession = jsonData.session;
    const cryptPublicKey = jsonData.public_key;

    const cryptData = {};

    cryptData.old_password = oldPassword;
    cryptData.new_password = newPassword;

    const en = new JsEncrypt();
    en.setPublicKey(cryptPublicKey);
    const encrypted = en.encrypt(JSON.stringify(cryptData));

    return fetch(
        ROOT_URL+'/auth/crypt_change_pass/',
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            'ENCRYPTED-DATA': encrypted,
            'CRYPT-SESSION': cryptSession,
          },
        },
    );
  });

  return ans;
}
